<template>
  <l-cache ref="cache" :get-data="getItem" :id="id">
    <CommonConfig slot-scope="{data}"  :owner-id-prop="data.ownerId" :owner-type-prop="data.ownerType" :status-prop="data.status"></CommonConfig>
  </l-cache>
</template>
<script>
import CommonConfig from './commonConfig'
export default {
  components: {CommonConfig},
  data () {
    return {
      id: ''
    }
  },
  created () {
    if (this.$route.query.ownerId === '') {
      this.id = 'newConfig'
    }
    else {
      this.id = this.$route.query.ownerId
    }
  },
  methods: {
    async getItem (key) {
      let data = {
        ownerId: (this.$route.query.ownerId === null) ? '' : this.$route.query.ownerId,
        status: this.$route.query.status,
        ownerType: this.$route.query.ownerType
      }
      return data
    }
  }
}
</script>
